import {
  signInWithPopup,
  signInWithRedirect,
  getRedirectResult,
  GoogleAuthProvider,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut as firebaseSignOut,
  onAuthStateChanged
} from 'firebase/auth';
import { auth } from './firebase';
import { createOrUpdateUserProfile } from './firestore';

const googleProvider = new GoogleAuthProvider();

// Detect if running on iOS Safari
const isIOSSafari = () => {
  const ua = window.navigator.userAgent;
  const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
  const webkit = !!ua.match(/WebKit/i);
  const iOSSafari = iOS && webkit && !ua.match(/CriOS/i);
  return iOSSafari;
};

export async function signInWithGoogle() {
  try {
    // Use redirect for iOS Safari, popup for others
    if (isIOSSafari()) {
      await signInWithRedirect(auth, googleProvider);
      // Result will be handled by getRedirectResult in firebase.js or app initialization
      return null;
    } else {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;

      // Update user profile in Firestore
      await createOrUpdateUserProfile(user.uid, {
        displayName: user.displayName,
        email: user.email,
        photoURL: user.photoURL,
        provider: 'google'
      });

      return user;
    }
  } catch (error) {
    console.error('Error signing in with Google:', error);
    throw error;
  }
}

// Handle redirect result (call this on app initialization)
export async function handleRedirectResult() {
  try {
    const result = await getRedirectResult(auth);
    if (result?.user) {
      // Update user profile in Firestore
      await createOrUpdateUserProfile(result.user.uid, {
        displayName: result.user.displayName,
        email: result.user.email,
        photoURL: result.user.photoURL,
        provider: 'google'
      });
      return result.user;
    }
    return null;
  } catch (error) {
    console.error('Error handling redirect result:', error);
    throw error;
  }
}

export async function signInWithEmail(email, password) {
  try {
    const result = await signInWithEmailAndPassword(auth, email, password);
    return result.user;
  } catch (error) {
    console.error('Error signing in with email:', error);
    throw error;
  }
}

export async function signUpWithEmail(email, password, displayName) {
  try {
    const result = await createUserWithEmailAndPassword(auth, email, password);
    const user = result.user;

    // Update user profile
    await createOrUpdateUserProfile(user.uid, {
      displayName: displayName || 'Anonymous Drunk',
      email: user.email,
      provider: 'email'
    });

    return user;
  } catch (error) {
    console.error('Error signing up:', error);
    throw error;
  }
}

export async function signOut() {
  try {
    await firebaseSignOut(auth);
  } catch (error) {
    console.error('Error signing out:', error);
    throw error;
  }
}

export function onAuthChange(callback) {
  return onAuthStateChanged(auth, callback);
}
